'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Nav, NavDrawer } from '../Nav';
import { headerCssClassNames } from './headerCssClassNames';
import { useHeaderState } from './HeaderStateContext';
export const HeaderNavigation = () => {
    const { navigationPosition, navigationItems, isSmallMobile, isMobile, isTablet, isContained, isSticky, isMobileMenuOpen, mobileMenuPosition, handleMobileMenuClose } = useHeaderState();
    const showMobileMenu = isSmallMobile || isMobile || isTablet;
    return showMobileMenu ? (_jsx(NavDrawer, { anchor: mobileMenuPosition, "aria-label": 'App Mobile Menu', className: headerCssClassNames.mobileNavigation, items: navigationItems, onClose: handleMobileMenuClose, open: isMobileMenuOpen })) : (_jsx(Nav, { "aria-label": 'App Navigation', className: headerCssClassNames.navigation, isContained: isContained, isSticky: isSticky, items: navigationItems, variant: navigationPosition }));
};
